import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';


import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withInterceptorsFromDi
} from '@angular/common/http';
import {SharedModule} from './shared/shared.module';
import {HomeComponent} from "./home/home.component";
import {HeaderComponent} from "./commons/header/header.component";
import {FooterComponent} from "./commons/footer/footer.component";
import {SpecialtiesSectionComponent} from "./home/specialties-section/specialties-section.component";
import {RequestInterceptor} from "./core/helpers/request.interceptor";
import localeFr from '@angular/common/locales/fr';
import {registerLocaleData} from "@angular/common";
import {DoctorsSectionComponent} from "./home/doctors-section/doctors-section.component";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

registerLocaleData(localeFr);
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
    declarations: [
      AppComponent,
      HomeComponent,
      HeaderComponent,
      FooterComponent,
      SpecialtiesSectionComponent,
      DoctorsSectionComponent

    ],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true,
        },
        { provide: LOCALE_ID, useValue: 'fr-FR' }

    ]
})

export class AppModule { }
